import { UserCommentsService } from '@fair-play/infra';
import { inject } from '@angular/core';
import { map, Observable, switchMap } from 'rxjs';
import { GetUserCommentQueryResult, GroupedComment } from './get-user-comment.query-result';
import { ActivatedRoute, Params } from '@angular/router';
import { CommentTypeEnum, GetUserCommentsPathParams, GetUserCommentsResponse } from '@core-http';
import { DateFormats, formatDateToString } from '@core';

export class GetUserCommentQueryHandler {
  private readonly userCommentsService: UserCommentsService = inject(UserCommentsService);
  private readonly activatedRoute: ActivatedRoute = inject(ActivatedRoute);

  getComment(): Observable<GetUserCommentQueryResult> {
    return this.activatedRoute.params.pipe(
      switchMap((params: Params) => {
        const pathParams: GetUserCommentsPathParams = { userId: params['id'] };
        return this.userCommentsService.getComment(pathParams);
      }),
      map((dto: GetUserCommentsResponse) => this.mapToQueryResult(dto))
    );
  }

  private mapToQueryResult(dto: GetUserCommentsResponse): GetUserCommentQueryResult {
    const groupedComments: Record<CommentTypeEnum, GroupedComment> = dto?.comments?.reduce(
      (acc, comment) => {
        const { commentType, createdAt, author } = comment;

        return {
          ...acc,
          [commentType]: {
            commentType,
            commentDetails: [
              ...(acc?.[commentType]?.commentDetails || []),
              { authorName: author.authorName, createdAt: formatDateToString(createdAt, DateFormats.DayMonthYearDot) }
            ]
          }
        };
      },
      {} as Record<CommentTypeEnum, GroupedComment>
    );

    const groupedCommentsArray: GroupedComment[] = Object.values(groupedComments);

    return {
      totalComments: dto.comments?.length || 0,
      groupedComments: groupedCommentsArray
    };
  }
}
